import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_LIGHT } from "@/lib/content";

export const Preloader = () => {
  const [done, setDone] = useState(() => {
    if (typeof window === "undefined") return true;
    return sessionStorage.getItem("lr_preloaded") === "1";
  });

  useEffect(() => {
    if (done) return;
    document.body.style.overflow = "hidden";
    const id = setTimeout(() => {
      setDone(true);
      sessionStorage.setItem("lr_preloaded", "1");
    }, 1800);
    return () => {
      clearTimeout(id);
      document.body.style.overflow = "";
    };
  }, [done]);

  useEffect(() => {
    if (done) document.body.style.overflow = "";
  }, [done]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          key="preloader"
          data-testid="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-navy"
        >
          <motion.img
            src={LOGO_LIGHT}
            alt="La Rondine Charter"
            initial={{ opacity: 0, scale: 0.9, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="w-44 md:w-56"
          />
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.6, ease: [0.65, 0, 0.35, 1] }}
            className="mt-8 h-px w-40 origin-left bg-canvas/40"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
